export const featureKey = 'genesysCloudCobrowse';
